import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ButtonLink } from 'components/Button/ButtonLink'
import { WORKSPACE_SELECTION_PATH } from 'paths'
import { Button } from 'components/Button'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useSession } from 'hooks/useSession'
import { Modal, useModals } from 'almanac-ui/Modal'
import { useDispatch } from 'react-redux'
import { setDocumentSettingsModalVisible } from 'redux/actions'
import { BillingFrequency } from 'components/Paywall/UpgradePlanModal/UpgradePlanModal'
import { BillingFrequencyRadioButtons } from '../../BillingFrequencyRadioButtons/BillingFrequencyRadioButtons'
import { useCreateAutopilotWorkspace } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/hooks/useCreateAutopilotWorkspace'
import Styles from './HeaderContent.module.scss'

import { Lightning } from 'blaze-ui/icons'
import { useShowVirtualMarketerUpgradeCta } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/hooks/useShowVirtualMarketerUpgradeCta'

interface HeaderContentProps {
  setBillingFrequency: (frequency: BillingFrequency) => void
  billingFrequency: BillingFrequency
  onClose?: () => void
  showWorkspacesLink?: boolean
}

export const HeaderContent = ({
  setBillingFrequency,
  billingFrequency,
  showWorkspacesLink = false,
  onClose,
}: HeaderContentProps) => {
  const { isMobile } = useResponsiveDesign()
  const workspace = useCurrentWorkspace()
  const { logout } = useSession()
  const { closeModal } = useModals()
  const dispatch = useDispatch()
  const { createAutopilotWorkspace } = useCreateAutopilotWorkspace()
  const { showCta: showVirtualMarketerUpgradeCta } = useShowVirtualMarketerUpgradeCta()

  const workspacePaying = workspace?.paying
  const subscriptionPaused = workspace?.collection_paused

  return (
    <>
      <Modal.Header
        onClose={onClose}
        title="Manage Subscription"
        preventClose={!workspace?.paying}
        actions={
          <>
            {!workspacePaying || subscriptionPaused ? (
              <>
                {showWorkspacesLink && (
                  <ButtonLink size="lg" variant="tertiary" to={WORKSPACE_SELECTION_PATH}>
                    Switch Workspace
                  </ButtonLink>
                )}
                <Button
                  variant="secondary"
                  size="lg"
                  onPress={() => {
                    closeModal()
                    logout()
                    dispatch(setDocumentSettingsModalVisible(false))
                  }}
                >
                  Log out
                </Button>
                {showVirtualMarketerUpgradeCta && (
                  <Button
                    frontIcon={Lightning}
                    onPress={createAutopilotWorkspace}
                    size="lg"
                    className={Styles.autopilotButton}
                  >
                    Try Autopilot
                  </Button>
                )}
              </>
            ) : (
              <>
                {!isMobile && (
                  <BillingFrequencyRadioButtons
                    billingFrequency={billingFrequency}
                    setBillingFrequency={setBillingFrequency}
                  />
                )}
              </>
            )}
          </>
        }
      />
    </>
  )
}
